import type { AssetKey, MarkerShape, PhaseKey } from './types';
import {
  TARIFF_USD_PER_KWH,
  YIELD_PER_KWP,
} from './solarModel';

/** Marker recolor mode (was a Claude Design editor knob in the source). */
export type ColorByMode = 'type' | 'phase' | 'suitability';
export const PROPS = {
  markerColorBy: 'type' as ColorByMode,
  tariff: TARIFF_USD_PER_KWH,
  yieldPerKwp: YIELD_PER_KWP,
};
export function colorBy(): ColorByMode {
  return PROPS.markerColorBy || 'type';
}

export const ASSET: Record<
  AssetKey,
  { label: string; short: string; color: string; shape: MarkerShape }
> = {
  solar: { label: 'Solar panel', short: 'SOLAR', color: '#FAA61A', shape: 'circle' },
  cabinet: { label: 'Cabinet', short: 'CABINET', color: '#3fcf8e', shape: 'square' },
};

export const PHASE: Record<PhaseKey, { label: string; short: string; color: string }> = {
  existing: { label: 'Existing', short: 'EXISTING', color: '#4cb8e8' },
  planned: { label: 'Planned', short: 'PLANNED', color: '#b478f0' },
  next: { label: 'Next phase', short: 'NEXT', color: '#e8923d' },
};

// Movement-derivation tuning — shared by src/lib/fleet.ts's deriveMotion and
// the server-side compute_traffic_bins() (supabase/migrations/20260819010300_traffic_bins.sql),
// which mirrors these values in SQL. Keep the two in sync.
export const DWELL_RADIUS_M = 60; // consecutive pings within this = parked
export const MAX_SPEED_KMH = 80; // segments faster than this are GPS glitches
export const MOVING_PING_WEIGHT = 0.2; // heatmap weight for pass-through pings vs 1.0 for dwell
